import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * `cn` — the shadcn-style class merge helper.
 *
 * `clsx` collapses falsy values, `twMerge` resolves Tailwind conflicts
 * ("px-4 px-6" → "px-6"). Use everywhere you compose Tailwind classes.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
